import { render } from "./RoleTree.vue?vue&type=template&id=9ab328bc&scoped=true"
import script from "./RoleTree.vue?vue&type=script&lang=js"
export * from "./RoleTree.vue?vue&type=script&lang=js"

import "./RoleTree.vue?vue&type=style&index=0&id=9ab328bc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ab328bc"]])

export default __exports__